var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"ma-2",attrs:{"icon":"mdi-account-cog-outline","prominent":"","text":"","type":"info"}},[_vm._v("\n        Non sono presenti impostazioni configurabile per "+_vm._s(_vm.model)+" per il momento.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }